export enum FIELD_NAMES {
  PASSWORD = "password",
  NEW_PASSWORD = "new_password",
}

export const MAX_FORM_FIELDS_LENGTH = 24;
export const MIN_PASSWORD_LENGTH = 6;
